<template>
  <div>
    <div class="multi-lang"> 
      <u class="linguval">{{$t('Content Redressal Mechanism')}} </u>
    </div  >
    <div v-html="dataset"> </div>
  </div>
</template>

<script>
export default {
 data() {
  return {
    dataset :''
  }
 },
 mounted () {
  document.title= "Content Redressal Mechanism - Ultra Jhakaas";   
  var allMetaElements = document.getElementsByTagName('meta');
  for(var metaValue = 0; metaValue < allMetaElements.length; metaValue ++) {
  if (allMetaElements[metaValue].getAttribute("name") == "description") { 
       allMetaElements[metaValue].setAttribute('content', "Content Redressal Mechanism - Ultra Jhakaas"); 
  } 

  if (allMetaElements[metaValue].getAttribute("property") == "og:description") { 
    allMetaElements[metaValue].setAttribute('content', "Content Redressal Mechanism - Ultra Jhakaas"); 
  } 

  if(allMetaElements[metaValue].getAttribute("name") == "twitter:description") { 
     allMetaElements[metaValue].setAttribute('content', "Content Redressal Mechanism - Ultra Jhakaas"); 
  } 
  if(allMetaElements[metaValue].getAttribute("name") == "keyword") { 
     allMetaElements[metaValue].setAttribute('content', "content redressal mechanism, Ultra Jhakaas content redressal,"); 

  }
  if(allMetaElements[metaValue].getAttribute("property") == "og:title") { 
     allMetaElements[metaValue].setAttribute('content', "Content Redressal Mechanism - Ultra Jhakaas"); 
  }
  if(allMetaElements[metaValue].getAttribute("name") == "twitter:title") { 
     allMetaElements[metaValue].setAttribute('content', "Content Redressal Mechanism - Ultra Jhakaas"); 
  }

}

document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  fetch('https://d2xowqqrpfxxjf.cloudfront.net/static/ultrajhakaas/en/redressal.html').then((res) => {
    return res.text()
  }).then((result) => {
    this.dataset = result;
  })
 }
}
</script>

<style>
.multi-lang{
  text-align: center;
  color: white;
  background-color: black;
  font-size: 24px !important;
  font-weight:bold;
}

.linguval{
   
    position: relative;
    top:20px;
}
</style>
